<ng-template #templatePortalContent>
  <div class="santa-flex santa-flex-col santa-w-full" subtree childList (allianceMutationObserver)="onHeaderMutation()">
    <ng-container *ngIf="topContent">
      <ng-container *polymorpheusOutlet="topContent"></ng-container>
    </ng-container>
    <ng-container *ngIf="centerContent">
      <ng-container *polymorpheusOutlet="centerContent"></ng-container>
    </ng-container>
    <ng-container *ngIf="botContent">
      <ng-container *polymorpheusOutlet="botContent"></ng-container>
    </ng-container>
  </div>
</ng-template>

<!-- для ssr -->
<ng-container *ngIf="platform.isServer">
  <ng-container *ngTemplateOutlet="templatePortalContent"></ng-container>
</ng-container>
